import './config/bootstrap/bootstrap.scss'
import './main.scss'

import './config/jquery'
import './config/isotope'

import 'bootstrap'
import 'bootstrap-select'
import 'owl.carousel'
import 'owl.carousel2.thumbs'
import 'jquery-zoom/jquery.zoom'
import 'lazyloadxt/dist/jquery.lazyloadxt.min.js'
import { tns } from 'tiny-slider/src/tiny-slider'

import './legacy/custom'

import './quickAddToCart'

if ($('.campaignSlider').length) {
  const options = {
    container: '.campaignSlider',
    items: 1,
    slideBy: 'page',
    autoplay: true,
    loop: true,
    speed: 1000,
    autoplayTimeout: 8000,
    nav: true,
    autoplayButtonOutput: false,
    navPosition: 'bottom',
    controls: true,
    controlsText: ['«', '»'],
  }

  if (window.editmode) {
    options.loop = false
  }

  window.slider = tns(options)
}
